import { AmenitiesInput } from '@apps/gated-2021/components/amenities-input';
import { NumberInput } from '@apps/gated-2021/components/number-input';
import { SubmitButton } from '@apps/gated-2021/components/submit-button';
import * as api from '@lib/api';
import { addressAtom, bathsAtom, bedroomsAtom, useAmenitiesAndSurroundingsState } from '@src/state';
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useRecoilState, useRecoilValue } from 'recoil';
import ChartPreview from '../components/chart-preview';
import { ContentView } from '../components/content-view.styled';
import { Form } from '../components/form';
import { Subtitle, Title } from '../components/form.styled';
import PageView from '../components/page-view';
import { EstimatorPath } from '../constants';
import { useAnalytics } from '../lib/analytics';
import * as styled from './gather-property-details.styled';

const GatherPropertyDetails: React.FC<{
    onBack: () => void;
    onNext: () => void;
    scrollTarget: React.RefObject<HTMLDivElement>;
}> = ({ onBack, onNext, scrollTarget }) => {
    const address = useRecoilValue(addressAtom);
    const [bedrooms, setBedrooms] = useRecoilState(bedroomsAtom); // prettier-ignore
    const [baths, setBaths] = useRecoilState(bathsAtom); // prettier-ignore
    const [amenitiesAndSurroundings, setAmenitiesAndSurroundings] =
        useAmenitiesAndSurroundingsState();
    const analytics = useAnalytics();

    if (!address) {
        return <Navigate to={EstimatorPath.Search} />;
    }

    const onSubmit = () => {
        api.emitAnalytics('step-features-complete', analytics);
        onNext();
    };

    return (
        <PageView dataCy="gather-property-details" scrollTarget={scrollTarget}>
            <ContentView>
                <Form onBack={onBack}>
                    <Title>Let&#39;s gather some details</Title>
                    <Subtitle bold>{address}</Subtitle>
                    <styled.Inputs>
                        <styled.BedroomsInput>
                            <NumberInput label="Bedrooms" value={bedrooms} onChange={setBedrooms} />
                        </styled.BedroomsInput>
                        <styled.BathroomsInput>
                            <NumberInput
                                label="Bathrooms"
                                value={baths}
                                onChange={setBaths}
                                step={0.5}
                            />
                        </styled.BathroomsInput>
                        <styled.AmenitiesInput>
                            <AmenitiesInput
                                label="Amenities"
                                value={amenitiesAndSurroundings}
                                onChange={setAmenitiesAndSurroundings}
                            />
                        </styled.AmenitiesInput>
                        <styled.SubmitButton>
                            <SubmitButton onClick={onSubmit} spinnerSize={56} />
                        </styled.SubmitButton>
                    </styled.Inputs>
                </Form>
                <ChartPreview title="Calculating income..." />
            </ContentView>
        </PageView>
    );
};

export default GatherPropertyDetails;
